export default "__VITE_ASSET__akPXHfx5__"